import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { fetcher } from '~lib/api/fetch';

import QueryKeys from '../queryKeys';
import useGetMyInfoQuery from '../user/useMyInfoQuery';

export interface ICompanyCultureReview {
  content: string;
  answers: {
    content: string;
    count: number;
    rate: number;
  }[];
}

export interface ICompanyCultureReviewChart {
  leftData: {
    legend: string;
    count: number;
    rate: number;
  };
  rightData: {
    legend: string;
    count: number;
    rate: number;
  };
}
export interface ICompanyCultureReviewResponse {
  cultureList: {
    content: string;
    chartData: ICompanyCultureReviewChart;
  }[];
  isAllEmpty: boolean;
}

export default function useGetCompanyCultureReviewQuery(companyHash: string) {
  const { isActiveUser } = useGetMyInfoQuery();

  return useQuery<ICompanyCultureReview[], AxiosError, ICompanyCultureReviewResponse>(
    [QueryKeys.companyReviewCulture, companyHash, isActiveUser],
    () => fetcher(`/api/review/culture?PK_NM_HASH=${companyHash}`),
    {
      enabled: !!companyHash && isActiveUser,
      select: (response) => {
        return getChartData(response);
      },
    },
  );
}

function getChartData(data: ICompanyCultureReview[]): ICompanyCultureReviewResponse {
  const cultureList = data.map((item) => {
    return {
      content: item.content,
      chartData: {
        leftData: {
          legend: item.answers[0].content,
          rate: item.answers[0].rate,
          count: item.answers[0].count,
        },
        rightData: {
          legend: item.answers[1].content,
          rate: item.answers[1].rate,
          count: item.answers[1].count,
        },
      },
      isEmpty: item.answers[0].count === 0 && item.answers[1].count === 0,
    };
  });

  const isAllEmpty = cultureList.every((item) => item.isEmpty);

  return { cultureList, isAllEmpty };
}
